/** @jsxImportSource @emotion/react */

import { MessageOutlined } from "@ant-design/icons";
import { Button, notification } from "antd";
import { useTranslation } from "react-i18next";

import { MessageStyle } from "./index.style";

const Message = () => {
  const { i18n } = useTranslation();
  const [api, contextHolder] = notification.useNotification();

  const onClick = () => {
    const currentLang = (
      i18n.language ||
      localStorage.getItem("i18nLng") ||
      "tr"
    ).toLowerCase();

    let msg = "Coming soon!";
    if (currentLang.startsWith("tr")) {
      msg = "Çok yakında!";
    } else if (currentLang.startsWith("zh")) {
      msg = "即將推出！";
    } else if (currentLang.startsWith("vi")) {
      msg = "Sắp ra mắt!";
    } else {
      msg = "Coming soon!";
    }

    api.info({
      message: msg,
      description: "",
      duration: 2,
      key: "desktop-contact-coming-soon",
    });
  };

  return (
    <div css={MessageStyle.self}>
      {contextHolder}
      <div css={MessageStyle.group}>
        <Button
          size="small"
          icon={<MessageOutlined />}
          css={MessageStyle.btnBackToTop}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default Message;
